module.exports = __webpack_public_path__ + "img/thumbnail_Springbok_m_normal.2d662cf4.png";